import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import baseURL from '../url';
import './Cart.css';
import whatsappIcon from '../../images/wpp.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda';
import Swal from 'sweetalert2';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

Modal.setAppElement('#root');

export default function Cart() {
    const [cartItems, setCartItems] = useState([]);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalIsOpen2, setModalIsOpen2] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [noteText, setNoteText] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [telefono, setTelefono] = useState('');
    const [codigo, setCodigo] = useState('');
    const [contactos, setContactos] = useState([]);
    const [descuento, setDescuento] = useState(0);
    const [codigoValido, setCodigoValido] = useState(false);
    const [totalPrice, setTotalPrice] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('efectivo');
    const [deliveryOption, setDeliveryOption] = useState('delivery');
    const [address, setAddress] = useState('');
    const [codigos, setCodigos] = useState([]);
    const [mensaje, setMensaje] = useState('');

    // Suma total de TODAS las variantes del mismo producto
    const getCantidadTotalProducto = (idProducto) => {
        return cartItems
        .filter(item => item.idProducto === idProducto)
        .reduce((total, item) => total + item.cantidad, 0);
    };

    // Precio mayoreo si suma total >= 6
    const getPrecioActual = (item) => {
        const cantidadTotal = getCantidadTotalProducto(item.idProducto);
        const esMayoreo = cantidadTotal >= 6 && item.precioAnterior > 0;
        return esMayoreo? item.precioAnterior : item.precio;
    };

    const getTipoPrecio = (item) => {
        const cantidadTotal = getCantidadTotalProducto(item.idProducto);
        return cantidadTotal >= 6 && item.precioAnterior > 0? 'mayoreo' : 'menudeo';
    };

    const obtenerImagen = (item) => {
        return item.imagen1 || item.imagen2 || item.imagen3 || item.imagen4 || null;
    };

    // Calcula total cada vez que cambian los items
    useEffect(() => {
        let totalPriceCalc = 0;
        cartItems.forEach(item => {
            const precioAplicado = getPrecioActual(item);
            totalPriceCalc += precioAplicado * item.cantidad;
        });
        setTotalPrice(totalPriceCalc);
    }, [cartItems]);

    useEffect(() => {
        cargarContacto();
        cargarCodigos();
        cargarProductos();
    }, []);

    // Carga items del carrito con cartId único

    useEffect(() => {
        const fetchCartItems = async () => {
            const cart = JSON.parse(localStorage.getItem('cart')) || [];
            
            if (productos.length === 0) {
                setLoading(false); // CLAVE: si no hay productos, igual quita el loading
                setCartItems([]);
                return;
            }

            const promises = cart.map(async (cartItem) => {
                const producto = productos.find(p => p.idProducto === cartItem.idProducto);
                if (!producto) return null;
                return {
                ...producto,
                    cantidad: cartItem.cantidad,
                    item: cartItem.item || [],
                    cartId: cartItem.cartId,
                };
            });

            const items = await Promise.all(promises);
            setCartItems(items.filter(i => i && i.idProducto));
            setLoading(false);
        };

        fetchCartItems();
    }, [productos, isFocused]);




    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`)
        .then(res => res.json())
        .then(data => setContactos(data.contacto?.reverse()[0] || []))
        .catch(error => console.error('Error al cargar contactos:', error));
    };

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`)
        .then(res => res.json())
        .then(data => setProductos(data.productos || []))
        .catch(error => console.error('Error al cargar productos:', error));
    };

    const cargarCodigos = () => {
        fetch(`${baseURL}/codigosGet.php`)
        .then(res => res.json())
        .then(data => setCodigos(data.codigos || []))
        .catch(error => console.error('Error al cargar códigos:', error));
    };

    const openModal = () => {
        setModalIsOpen(true);
        setIsFocused(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setIsFocused(false);
    };

    const openModal2 = () => setModalIsOpen2(true);
    const closeModal2 = () => setModalIsOpen2(false);

    // Borra por cartId, no por idProducto
    const removeFromCart = (cartId) => {
        const updatedCart = cartItems.filter(item => item.cartId!== cartId);
        setCartItems(updatedCart);

        const localCart = JSON.parse(localStorage.getItem('cart')) || [];
        const updatedLocalCart = localCart.filter(item => item.cartId!== cartId);
        localStorage.setItem('cart', JSON.stringify(updatedLocalCart));
        window.dispatchEvent(new Event('storage'));
        toast.info('Producto eliminado');
    };



    const clearCart = () => {
        Swal.fire({
            title: '¿Vaciar carrito?',
            text: 'Se eliminarán todos los productos',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, vaciar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                localStorage.removeItem('cart');
                setCartItems([]);
                setModalIsOpen(false); // Cierra el modal ANTES de disparar el evento
                setTimeout(() => {
                    window.dispatchEvent(new Event('storage'));
                }, 100);
                toast.success('Carrito vaciado');
            }
        });
    };

    const updateLocalCart = (cartId, nuevaCantidad) => {
        const localCart = JSON.parse(localStorage.getItem('cart')) || [];
        const itemIndex = localCart.findIndex(item => item.cartId === cartId);
        if (itemIndex!== -1) {
            localCart[itemIndex].cantidad = nuevaCantidad;
            localStorage.setItem('cart', JSON.stringify(localCart));
        }
    };

    const increaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        const item = updatedCartItems[index];

        // Validar stock
        if (item.cantidad >= item.stock) {
            toast.error(`Stock máximo: ${item.stock}`);
            return;
        }

        updatedCartItems[index].cantidad += 1;
        setCartItems(updatedCartItems);
        updateLocalCart(updatedCartItems[index].cartId, updatedCartItems[index].cantidad);
    };

    const decreaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        if (updatedCartItems[index].cantidad > 1) {
            updatedCartItems[index].cantidad -= 1;
            setCartItems(updatedCartItems);
            updateLocalCart(updatedCartItems[index].cartId, updatedCartItems[index].cantidad);
        }
    };

    const handleWhatsappMessage = () => {
        const codigoDescuento = codigos.find(item => item.codigo === codigo);
        let descuentoActualizado = 0;

        if (codigoDescuento) {
            descuentoActualizado = codigoDescuento.descuento;
            setCodigoValido(true);
        } else {
            setCodigoValido(false);
        }

        let totalPriceCalc = 0;
        cartItems.forEach(item => {
            totalPriceCalc += getPrecioActual(item) * item.cantidad;
        });

        let totalPriceWithDiscount = Math.max(0, totalPriceCalc - descuentoActualizado);
        const formattedTotalPrice = totalPriceWithDiscount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        const phoneNumber = contactos.telefono;

        const cartDetails = cartItems.map((item) => {
            const precioReal = getPrecioActual(item);
            const tipo = getTipoPrecio(item);
            const variante = item.item && item.item.length > 0? `\n Variante: ${item.item[0]}` : '';
            return `\n✅ *${item.titulo}*${variante}\n Cantidad: ${item.cantidad}\n Precio: ${moneda} ${precioReal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} ${tipo === 'mayoreo'? '(Mayoreo)' : ''}`
        });

        let noteMessage = '';
        if (name.trim()!== '') noteMessage += `\n✅ Nombre: ${name}`;
        if (noteText.trim()!== '') noteMessage += `\n✅ Nota: ${noteText}`;
        if (codigo.trim()!== '') noteMessage += `\n✅ Código: ${codigo}\n✅ Descuento: ${moneda} ${descuentoActualizado.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;

        const entrega = deliveryOption === 'delivery'? `Dirección: ${address}` : 'Retiro personalmente';
        const paymentMessage = paymentMethod === 'efectivo'? 'Pago en efectivo' : 'Transferencia bancaria';

        const message = `¡Hola! 🌟 Quiero realizar el siguiente pedido:\n${cartDetails.join('')}\n------------------------------------>${noteMessage}\n✅ ${entrega}\n✅ ${paymentMessage}\n------------------------------------>\n\n*Total: ${moneda} ${formattedTotalPrice}*`;

        window.open(`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`, '_blank');

        setName('');
        setNoteText('');
        setCodigo('');
        setDescuento(descuentoActualizado);
        setModalIsOpen(false);
        setModalIsOpen2(false);
    };

    const crearPedido = async () => {
        if (!name ||!email ||!telefono || (deliveryOption === 'delivery' &&!address)) {
            toast.error('Completa todos los campos obligatorios');
            return;
        }

        setMensaje('Procesando...');

        try {
            const productosPedido = cartItems.map(item => ({
                titulo: item.titulo,
                cantidad: item.cantidad,
                item: item.item,
                precio: getPrecioActual(item),
                precioTipo: getTipoPrecio(item),
                imagen: obtenerImagen(item),
                cartId: item.cartId
            }));

            let totalPriceCalc = 0;
            cartItems.forEach(item => {
                totalPriceCalc += getPrecioActual(item) * item.cantidad;
            });

            const codigoDescuento = codigos.find(item => item.codigo === codigo);
            const descuentoCodigo = codigoDescuento? codigoDescuento.descuento : 0;
            const totalPriceWithDiscount = totalPriceCalc - descuentoCodigo;

            const formData = new FormData();
            formData.append('productos', JSON.stringify(productosPedido));
            formData.append('total', totalPriceWithDiscount);
            formData.append('nombre', name);
            formData.append('email', email);
            formData.append('telefono', telefono);
            formData.append('entrega', deliveryOption === 'delivery'? address : 'Retiro personalmente');
            formData.append('pago', paymentMethod);
            formData.append('nota', noteText);
            formData.append('codigo', codigo);
            formData.append('estado', 'Pendiente');

            const response = await fetch(`${baseURL}/pedidoPost.php`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();
            if (data.mensaje) {
                setMensaje('');
                Swal.fire('Pedido enviado!', data.mensaje, 'success');
                handleWhatsappMessage();
                setName('');
                setEmail('');
                setTelefono('');
                setCodigo('');
                setNoteText('');
                setAddress('');
                closeModal();
                closeModal2();
                clearCart();
            } else if (data.error) {
                setMensaje('');
                Swal.fire('Error', data.error, 'error');
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            Swal.fire('Error', 'Error de conexión. Por favor, inténtelo de nuevo.', 'error');
        }
    };

    return (
        <div>
            <ToastContainer />
            <button onClick={openModal} className='cartIconFixed'>
                {cartItems.length >= 1 && <span>{cartItems.length}</span>}
                <FontAwesomeIcon icon={faShoppingCart} />
            </button>
            <Modal
                isOpen={modalIsOpen}
                className="modal-cart"
                overlayClassName="overlay-cart"
                onRequestClose={closeModal}
            >
                <div className='deFLex'>
                    <button onClick={closeModal}><FontAwesomeIcon icon={faArrowLeft} /></button>
                    <button onClick={clearCart} className='deleteToCart'>Vaciar carrito</button>
                </div>
                {cartItems.length === 0? (
                    <p className='nohay'>No hay productos</p>
                ) : (
                    <>
                        <div className="modal-content-cart">
                            {loading? (
                                <p>Cargando...</p>
                            ) : (
                                <div>
                                    {cartItems.map((item, index) => {
                                        const precioReal = getPrecioActual(item);
                                        const esMayoreo = getTipoPrecio(item) === 'mayoreo';

                                        return (
                                            <div key={item?.cartId} className='cardProductCart'>
                                                <Anchor to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`} onClick={closeModal}>
                                                    <img src={obtenerImagen(item)} alt="imagen" />
                                                </Anchor>
                                                <div className='cardProductCartText'>
                                                    <h3>{item.titulo}</h3>

                                                    {item?.item?.length > 0 && (
                                                        <span>{item.item[0]}</span>
                                                    )}

                                                    <strong>
                                                        {moneda} {precioReal?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                        {esMayoreo && <span className="mayoreo-tag"> Mayoreo</span>}
                                                    </strong>
                                                    {esMayoreo && (
                                                        <small style={{ textDecoration: 'line-through', color: '#888', display: 'block' }}>
                                                            {moneda} {item?.precio?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                        </small>
                                                    )}
                                                </div>
                                                <div className='deColumn'>
                                                    <button onClick={() => removeFromCart(item.cartId)} className='deleteCart'>
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                    <div className='deFlexCantidad'>
                                                        <button onClick={() => decreaseQuantity(index)}>-</button>
                                                        <span>{item.cantidad}</span>
                                                        <button onClick={() => increaseQuantity(index)}>+</button>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            )}
                        </div>
                        <div className='deColumnCart'>
                            <h4>Total: {moneda} {totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h4>
                            <div className='deFLexBtns'>
                                <button className='btnWpp' onClick={openModal2}>
                                    Pedir por WhatsApp<img src={whatsappIcon} alt="WhatsApp" />
                                </button>
                            </div>
                        </div>

                        <Modal
                            isOpen={modalIsOpen2}
                            onRequestClose={closeModal2}
                            className="modal-cart"
                            overlayClassName="overlay-cart"
                        >
                            <div className='deFLex'>
                                <button onClick={closeModal2}><FontAwesomeIcon icon={faArrowLeft} /></button>
                                <h4>Agregar Detalles</h4>
                            </div>
                            <div className="modal-send-form">
                                <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder='Nombre (obligatorio)' />
                                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder='Email (obligatorio)' />
                                <input type="number" value={telefono} onChange={(e) => setTelefono(e.target.value)} placeholder='Telefono (obligatorio)' />

                                <div className='deFLexRadio'>
                                    <label>Opciones de entrega</label>
                                    <div onClick={() => setDeliveryOption('delivery')}>
                                        <input type="radio" id="delivery" name="deliveryOption" value="delivery" checked={deliveryOption === 'delivery'} onChange={() => setDeliveryOption('delivery')} />
                                        <label htmlFor="delivery">Envío a domicilio</label>
                                    </div>
                                    <div onClick={() => setDeliveryOption('pickup')}>
                                        <input type="radio" id="pickup" name="deliveryOption" value="pickup" checked={deliveryOption === 'pickup'} onChange={() => setDeliveryOption('pickup')} />
                                        <label htmlFor="pickup">Retirar personalmente</label>
                                    </div>
                                </div>

                                {deliveryOption === 'delivery' && (
                                    <input type="text" value={address} onChange={(e) => setAddress(e.target.value)} placeholder="Ingresa tu dirección (obligatorio)" />
                                )}

                                <div className='deFLexRadio'>
                                    <label>Formas de pago</label>
                                    <div>
                                        <input type="radio" id="efectivo" name="paymentMethod" value="efectivo" checked={paymentMethod === 'efectivo'} onChange={() => setPaymentMethod('efectivo')} />
                                        <label htmlFor="efectivo">Efectivo</label>
                                    </div>
                                    <div>
                                        <input type="radio" id="transferencia" name="paymentMethod" value="transferencia" checked={paymentMethod === 'transferencia'} onChange={() => setPaymentMethod('transferencia')} />
                                        <label htmlFor="transferencia">Transferencia</label>
                                    </div>
                                </div>

                                <input type="text" value={codigo} onChange={(e) => setCodigo(e.target.value)} placeholder='Código de descuento (opcional)' />
                                <textarea value={noteText} onChange={(e) => setNoteText(e.target.value)} placeholder='Nota adicional (opcional)' />

                                {mensaje && <p>{mensaje}</p>}

                                <button onClick={crearPedido} className='btnEnviar'>
                                    Enviar Pedido
                                </button>
                            </div>
                        </Modal>
                    </>
                )}
            </Modal>
        </div>
    );
}